import React from 'react'
import Icon from '../Icon'

/**
* Check Icon
*/
function CheckIcon(props) {
  return (
    <Icon
      icon="check"
      aria-hidden
      role="presentation"
      {...props}
    >
      <g>
        <path d="M9 16.17l-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41z" />
      </g>
    </Icon>
  )
}

export default CheckIcon
